import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/autoreg/accounts/store/action.type";
import {DefaultResponseType} from "@/shared/types/defaultResponse.type";
import {HttpErrorResponse} from "@angular/common/http";
import {AutoRegItemType} from "@/main/autoreg/accounts/store/type/autoRegItem.type";

export const autoRegAddToGroupAction = createAction(
  ActionType.AUTO_REG_ADD_TO_GROUP,
  props<{group: string, typeRequest: 'one' | 'all', account?: AutoRegItemType}>()
)

export const autoRegAddToGroupActionSuccess = createAction(
  ActionType.AUTO_REG_ADD_TO_GROUP_SUCCESS,
  props<{response: DefaultResponseType, logins: string[], groupName: string}>()
)

export const autoRegAddToGroupActionFailure = createAction(
  ActionType.AUTO_REG_ADD_TO_GROUP_FAILURE,
  props<{error: HttpErrorResponse}>()
)
